import { createSelector } from 'reselect';
import { ZoneName, PapiInstallableModuleType } from '../../types/zones';
import { AppState } from '../../types/store';
import { getAllModules } from './modules';
import { getLayout } from './layout';
import { Gruser } from '../../types/papi';

export const getZones = (state: AppState, gruser: Gruser | undefined) =>
  getLayout(state, gruser)?.zones || {};

export const getZone = createSelector(
  getZones,
  (_, __, zoneName: ZoneName) => zoneName,
  (zones, zoneName) => zones?.[zoneName]
);

export const getZoneModules = createSelector(
  (state: any) => state,
  (_, gruser: Gruser | undefined) => gruser,
  (_, __, zoneName: ZoneName) => zoneName,
  (state, gruser, zoneName) => {
    const zone = getZone(state, gruser, zoneName);
    const modules = getAllModules(state, gruser);

    if (!zone || !modules) {
      return [];
    }

    return zone.installedModulesIds.map(id => modules[id]).filter(Boolean);
  }
);

export const getInstallableModules = createSelector(
  (state: any) => state,
  (_, gruser: Gruser | undefined) => gruser,
  (_, __, zoneName: ZoneName) => zoneName,
  (state, gruser, zoneName): PapiInstallableModuleType[] => {
    const zone = getZone(state, gruser, zoneName);

    if (!zone) {
      return [];
    }

    return zone.installableModuleTypes || [];
  }
);
